export default __webpack_public_path__ + "static/media/blog-img1.3cdc9440.png";